/**
 * FH-A11Y batch 24 (2026-10-03, removed 2026-10-14): temporary keyboard and screen reader fixes for the Rivyo
 * "Write a review" and "Ask a question" pop-ups. Removed because WebContrive (Rivyo) built these fixes into the app
 * itself (last items confirmed fixed in their email of Oct 14, retested the same day with this script switched off),
 * so the two no longer compete for focus or arrow keys.
 * Rollback: restore this file from theme "Gallery hover zoom fix 2026-10-13".
 * Batch 25 below (gift card balance page) is unrelated and unchanged.
 */

/**
 * FH-A11Y batch 25 (2026-10-04): gift card balance page (/pages/gift-card-balance, drawn by the gift card app).
 * Same look, apart from a keyboard focus outline on the code field and the "Check now" button. What changes:
 *   - the code field has a name ("Gift card code") instead of only a placeholder;
 *   - "Gift card not found" is read out and tied to the field; a found balance is read out too;
 *   - Enter in the field checks the code, the same as the button.
 * Does nothing on any other page.
 */
(function () {
  'use strict';
  if (window.__fhA11yBatch25) return;
  window.__fhA11yBatch25 = true;
  if (location.pathname.indexOf('gift-card-balance') === -1) return;

  var lastSaid = '';
  var timer = 0;

  function setAttr(el, n, v) { if (el && el.getAttribute(n) !== v) el.setAttribute(n, v); }
  function say(msg) { if (typeof window.fhA11yAnnounce === 'function') window.fhA11yAnnounce(msg, 200); }
  function text(el) { return el ? (el.innerText || el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }

  function addStyles() {
    if (document.getElementById('fh-a11y-batch25-css')) return;
    var st = document.createElement('style');
    st.id = 'fh-a11y-batch25-css';
    st.textContent =
      '.gvl-balance .gvl-form__item-wrapper:has(.gvl-input:focus-visible){outline:2px solid #404040!important;outline-offset:2px!important}' +
      '.gvl-balance .gvl-btn:focus-visible{outline:2px solid #404040!important;outline-offset:2px!important}' +
      '@supports not selector(:has(*)){.gvl-balance .gvl-input:focus-visible{outline:2px solid #404040!important;outline-offset:2px!important}}';
    document.head.appendChild(st);
  }

  function fix() {
    var root = document.querySelector('.gvl-balance');
    if (!root) return;
    addStyles();
    var input = root.querySelector('.gvl-balance-code-input');
    var button = root.querySelector('.gvl-balance-checkout-btn');
    if (input) {
      setAttr(input, 'aria-label', 'Gift card code');
      setAttr(input, 'autocomplete', 'off');
      if (!input.__fh25) {
        input.__fh25 = true;
        input.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' || e.isComposing) return;
          var b = root.querySelector('.gvl-balance-checkout-btn');
          if (!b || b.disabled) return;
          e.preventDefault();
          lastSaid = '';
          b.click();
        });
      }
    }
    if (button && !button.__fh25) {
      button.__fh25 = true;
      button.addEventListener('click', function () { lastSaid = ''; });
    }

    /* While a check is running the old message is still on screen: wait for the new result. */
    if (button && button.classList.contains('gvl-btn--loading')) return;

    var err = root.querySelector('.gvl-error-msg');
    var errText = text(err);
    if (err && errText) {
      if (!err.id) err.id = 'fh-gvl-balance-error';
      setAttr(input, 'aria-invalid', 'true');
      setAttr(input, 'aria-describedby', err.id);
      if (lastSaid !== 'e:' + errText) { lastSaid = 'e:' + errText; say(errText); }
      return;
    }
    if (input && input.getAttribute('aria-describedby') === 'fh-gvl-balance-error') {
      input.removeAttribute('aria-describedby');
      input.removeAttribute('aria-invalid');
    }

    var details = root.querySelector('.gvl-balance__details');
    if (details && !details.classList.contains('gvl-hidden')) {
      var found = text(details.querySelector('.gvl-card-details'));
      if (found && lastSaid !== 'd:' + found) {
        lastSaid = 'd:' + found;
        say(found.length > 240 ? found.slice(0, 240) : found);
      }
    }
  }

  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = 0; try { fix(); } catch (e) {} }, 120);
  }
  function start() {
    fix();
    /* The app draws the form after the page loads and redraws parts of it after each check. */
    var main = document.getElementById('MainContent') || document.body;
    new MutationObserver(schedule).observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
